import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's128g-s128m01',
    templateUrl: './s128g-s128m01.component.html'
})
export class S128gS128m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    revnbr: any = {};
    pymt1a: any = {};
    pymt1b: any = {};
    pymt1c: any = {};
    pymt1d: any = {};
    pymt1e: any = {};
    pymt2a: any = {};
    pymt2b: any = {};
    pymt2c: any = {};
    pymt2d: any = {};
    pymt2e: any = {};
    pymt3a: any = {};
    pymt3b: any = {};
    pymt3c: any = {};
    pymt3d: any = {};
    pymt3e: any = {};
    msgln: any = {};
    selmen: any = {'value': '2-SEL'};
    prev: any = {'value': '7-PREV'};
    next: any = {'value': '8-NEXT'};
    coup: any = {'value': '9-COUPON'};
    usag: any = {'value': '10-USAGE'};
    currc1: any = {'value': 'SH4-CUST INQ'};
    prevc1: any = {'value': 'SH3-PREV CUST INQ'};
    last: any = {'value': 'SH6-LAST'};
    first: any = {'value': 'SH7-FIRST'};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'revnbr', 'pymt1a', 'pymt1b', 'pymt1c', 'pymt1d', 'pymt1e', 'pymt2a', 'pymt2b', 'pymt2c', 'pymt2d', 'pymt2e', 'pymt3a', 'pymt3b', 'pymt3c', 'pymt3d', 'pymt3e', 'msgln', 'selmen', 'prev', 'next', 'coup', 'usag', 'currc1', 'prevc1', 'last', 'first'];
    public LINES: number[] = [1, 2, 4, 5, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
